// Centralized business identity used across all legal documents.
// Update here if the registered business details ever change.

export const BUSINESS = {
  name: "Tomaž Pernovšek s.p.",
  address: "Dolinškova ulica 10a, 1000 Ljubljana, Slovenia",
  vatNumber: "SI11630876", // Slovenian VAT identifier (davčna št. with SI prefix)
  taxNumber: "11630876", // davčna številka
  registrationNumber: "8841373000", // matična številka
  contactEmail: "info@journail.app",
  effectiveDate: "7 May 2026",
  lastUpdated: "7 May 2026",
} as const;
